<template>
	<div class="sa-list-component">
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="xl" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
					<template #cell(index)="row">
						{{ (currentPage - 1) * perPage + row.index + 1 }}
					</template>
					<template v-slot:cell(cognomeRagioneSoggetto)="{ item }">{{ item.cognomeRagioneSoggetto }} {{ item.nomeSoggetto }}</template>
					<template #cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button size="sm" variant="btn btn-outline-purple waves-effect waves-light width-sm no-text" style="margin-right: 5px" @click="onStampa(row.item)">
								<b-icon icon="printer"></b-icon>
							</b-button>
							<b-button size="sm" variant="btn btn-outline-info no-text" @click="onDownload(row.item)">
								<b-icon icon="download"></b-icon>
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	data() {
		return {
			currentPage: 1,
			rows: 0,
			perPage: 100,
			pathResource: "/contabilitadocumenti",
			items: [],
			fields: [
				{
					label: "N.",
					key: "index",
					thStyle: "width: 3rem",
				},
				{
					label: "Data",
					key: "dataDocumento",
					sortable: true,
					thStyle: "width: 7rem",
					formatter: (value) => {
						return moment(new Date(value)).format("DD-MM-YYYY");
					},
				},
				{
					label: "Num.",
					key: "numeroDocumento",
					thStyle: "width: 5rem",
					sortable: true,
				},
				{
					label: "Tipo Documento",
					key: "codiceTipoDocumento",
					thStyle: "width: 14rem",
					sortable: true,
				},
				{
					label: "Ragione Sociale",
					key: "cognomeRagioneSoggetto",

					sortable: true,
				},
				{
					label: "Totale",
					key: "totaleDocumento",
					sortable: true,
					//formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
					thStyle: "width: 7rem",
				},
				{ class: "sa-table-column-action-single", key: "actions", label: "" },
			],
		};
	},
	methods: {
		loadData(filtroDocumenti) {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResource, filtroDocumenti, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
	},
};
</script>

<style></style>
